import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const OFFER_DECLINED = {
  type: GQL.message_template_type_enum.OfferDeclined,
  emailSubject:
    "You have declined an offer from {{offer.schoolName}} / Ha declinado una oferta de {{offer.schoolName}}",
  emailHtml: html`<p>
      Dear {{parent.name}},<br />
      <br />
      You have declined an offer from {{offer.schoolName}} for {{student.name}},
      for grade {{grade}} for the {{enrollmentPeriod.name}}.<br />
      <br />
      If this was a mistake, please contact {{organization.name}}. You can
      review the status of {{student.name}}'s form anytime: {{applyUrl}}<br />
      <br />
      -{{organization.name}} Team<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      Ha declinado una oferta de {{offer.schoolName}} para {{student.name}},
      para el grado {{grade}} para el {{enrollmentPeriod.name}}.<br />
      <br />
      Si esto fue un error, por favor contacte a {{organization.name}}. Puede
      revisar el estado de la aplicación de {{student.name}} en cualquier
      momento: {{applyUrl}}<br />
      <br />
      -Equipo de {{organization.name}}<br />
    </p>`,
  emailText: `Dear {{parent.name}},

You have declined an offer from {{offer.schoolName}} for {{student.name}}, for grade {{grade}} for the {{enrollmentPeriod.name}}.

If this was a mistake, please contact {{organization.name}}. You can review the status of {{student.name}}'s form anytime: {{applyUrl}}

-{{organization.name}} Team

_____________________________________________

Estimado/a {{parent.name}},

Ha declinado una oferta de {{offer.schoolName}} para {{student.name}}, para el grado {{grade}} para el {{enrollmentPeriod.name}}.

Si esto fue un error, por favor contacte a {{organization.name}}. Puede revisar el estado de la aplicación de {{student.name}} en cualquier momento: {{applyUrl}}

-Equipo de {{organization.name}}`,
  sms: "You have declined an offer from {{offer.schoolName}} / Ha declinado una oferta de {{offer.schoolName}}",
};
